export type WebhookLogsState = {
  // filters applied to the webhook logs table
  filters: {
    // page: zero indexed pagination number
    page: number;
    // pageinateBy: count of webhook requests `per_page` in format table expects
    paginateBy: number;
    // dataCount: `total` count of webhook requests, in format table expects
    dataCount: number;
    // time: request_sent_at (range of two numbers in ms epoch time separated by a comma)
    time?: string;
    // name: webhook name, pulled via customer_webhook_uuid (allows multiple values separated by commas)
    name?: string;
    // event: webhook_event (allows multiple values separated by commas)
    event?: string;
    // endpoint: request_url (allows multiple values separated by commas)
    endpoint?: string;
    // response: response_status_code (allows multiple values separated by commas; string 'none' would mean null response)
    response?: string;
    // search: filters within the request body (allows multiple values separated by commas)
    search?: string;
    // retryOf: webhook request token, representing the first triggered request. NOT CURRENTLY USED ON FE
    retryOf?: string;
  };
  // options to populate the filter select dropdowns
  options: {
    // customer_webhook_name: "name" field on CustomerWebhooks table in Typhon
    name: string[];
    // webhook_event_description: "webhook_event" on webhook_requests, description from "request_data" in webhook_requests
    event: { query_string: string; display_string: string }[];
    // "response_status_code" from webhook-requests table
    response: string[];
    // "request_url" from webhook-requests table
    endpoint: string[];
  };
};

export const initialFilterState: Partial<WebhookLogsState['filters']> = {
  time: undefined,
  name: undefined,
  event: undefined,
  endpoint: undefined,
  response: undefined,
  search: undefined,
};
export type Filters = typeof initialFilterState;

const initialWebhookLogsState: WebhookLogsState = {
  filters: {
    page: 1,
    paginateBy: 10,
    dataCount: 0,
    retryOf: undefined,
    ...initialFilterState,
  },
  options: {
    name: [],
    event: [],
    response: [],
    endpoint: [],
  },
};

export default initialWebhookLogsState;
